import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnConfiguration } from '../models/column-config.model';
import { BarConfig, DataSourceRequester, TableConfiguration } from '../models/table-config.model';

@Injectable()
export class TableConfigurationBuilder {

  config: TableConfiguration; 

  create() {
    this.config = TableConfiguration.create(<TableConfiguration>{});
    return this;
  }

  withDataSource(getDataSource: DataSourceRequester) {
    this.config.getDataSource = getDataSource;
    return this;
  }

  withCounterDataSource(dataCounterSource: Observable<{count: number}>) {
    this.config.dataCounterSource = dataCounterSource;
    return this;
  }

  withDataMapper(
    mapper: (element: unknown, config?: TableConfiguration) => unknown,
  ) {
    this.config.mapData = (data: unknown[]) => {
      this.config.context = { ...this.config.context, items: data };
      const dataToReturn = data.map(element => mapper(element, this.config));
      return dataToReturn;
    };
    return this;
  }

  withColumns(columns: ColumnConfiguration[]) {
    this.config.columns = columns;
    return this;
  }

  withContext(context: Record<string, unknown>) {
    this.config.context = context;
    return this;
  }

  withBar(barConfig: BarConfig) {
    this.config.barConfig = barConfig;
    return this;
  }

  withoutHeader() {
    this.config.classes = { 'configurable-table--without-thead': true };
    return this;
  }
}
